<template>
  <div class="full">
    <div class="full" id="earth_div">
      <div class="full abspos">
        <div class="marginer">
          <h1>What's your nickname?</h1>
          <input class="textinput" type="text" placeholder="My nick name" v-model="newMe.name" />

          <br />
          <p>
            Photo
          </p>
          <input type="file" id="avatar" @change="onChangeImage">
          <p>
            Pin on Earth
          </p>
          <select v-model="country">
            <option :value="cc" :key="cc.numeric + cc.lat + cc.lng + cc.locale" v-for="cc in countries">{{ cc.country }}</option>
          </select>
          <p>
            Terms and Conditions
          </p>
          <span class="linker" @click="showPrivacy = !showPrivacy"> Read our Privacy Statement</span>
          <label for="agree"><input id="agree" name="agree" type="checkbox" v-model="newMe.agree"> Agree our Terms </label>

          <p>
            Submit
          </p>
          <button :disabled="uploading" @click="setNewMe">Pin Myself on the earth</button>
          <br />
          <p v-if="uploading">
            Uploading....
          </p>

          <div v-if="msgs.length > 0" >
            <div class="red" :key="msg.id" v-for="msg in msgs">{{ msg.msg }}</div>
          </div>
        </div>

        <!-- <pre v-if="debug">{{ Status.state }}</pre> -->
        <div class="marginer privacy-area" v-if="showPrivacy">
          <Privacy>
          </Privacy>
        </div>

      </div>
    </div>

    <YoEarthLoader class="full" @ready="run">
    </YoEarthLoader>
  </div>
</template>

<script>
import { Status } from '../parts/YoNetwork/YoNetwork.js'
import * as eAPI from '../SubCompos/eAPI.js'
import axios from 'axios'

export default {
  props: {
    earthID: {},
    userID: {}
  },
  components: {
    Privacy: () => import('../parts/YourName/Privacy.vue'),
    YoEarthLoader: () => import('./YoEarthLoader.vue')
  },
  data () {
    return {
      countries: require('../SubCompos/country.js').default,
      country: {
        'country': 'Hong Kong',
        'locale': 'HK',
        'locale3': 'HKG',
        'numeric': 344,
        'lat': 22.25,
        'lng': 114.1667
      },
      files: [],
      uploading: false,
      debug: true,
      showPrivacy: false,
      Status,
      newMe: {
        name: '',
        agree: false
      },
      msgs: [],
      media: false
    }
  },
  mounted () {

  },
  methods: {
    onChangeImage (evt) {
      this.files = evt.target.files
    },
    async onUpload ({ files }) {
      this.uploading = true
      let imgs = await eAPI.uploadMultipleFiles({ files })
      this.media = imgs[0]
      this.uploading = false
    },
    getByIP () {
      return axios({
        method: 'GET',
        headers: {
        },
        withCredentials: false,
        url: 'https://geoip-db.com/json'
      })
        .then((resp) => {
          /*
          {
            "country_code": "HK",
            "country_name": "Hong Kong",
            "city": "Central",
            "postal": null,
            "latitude": 22.2833,
            "longitude": 114.15,
            "IPv4": "113.252.0.0",
            "state": "Central and Western District"
          }
          */

          let result = resp.data
          return {
            lng: result.longitude,
            lat: result.latitude,
            locale: result.country_code,
            state: result.state,
            name: result.country_name
          }
        }, () => {
          return {
            lng: 0,
            lat: 0,
            locale: 'unknown',
            state: 'unknown',
            name: 'unknown'
          }
        })
    },
    async setNewMe () {
      this.msgs = []
      if (!this.newMe.agree) {
        if (this.msgs.findIndex(m => m.id === 0) === -1) {
          this.msgs.push({ id: 0, msg: 'Needs to agree our terms.' })
        }
      }
      if (!this.newMe.name.trim()) {
        if (this.msgs.findIndex(m => m.id === 1) === -1) {
          this.msgs.push({ id: 1, msg: 'Needs to fill in your nickname.' })
        }
      }

      if (this.msgs.length > 0) {
        return
      }

      let info = JSON.parse(JSON.stringify(this.newMe))
      delete info.agree
      Status.setChatter({ chatter: info })

      // let { lat, lng, locale } = await this.getByIP()

      this.$nextTick(async () => {
        console.log(Status.state)
        //
        let uuid = Status.state.chatter.uuid
        let name = Status.state.chatter.name

        try {
          await this.onUpload({ files: this.files })
        } catch (e) {

        }

        let newPin = await this.registerPin({
          data: {
            earthID: this.earthID,
            userID: this.userID,
            name: name,
            uuid: uuid,
            lat: this.country.lat,
            lng: this.country.lng,
            desc: '',
            locale: this.country.country,
            avatar: this.media || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0xMiAwYzYuNjIzIDAgMTIgNS4zNzcgMTIgMTJzLTUuMzc3IDEyLTEyIDEyLTEyLTUuMzc3LTEyLTEyIDUuMzc3LTEyIDEyLTEyem04LjEyNyAxOS40MWMtLjI4Mi0uNDAxLS43NzItLjY1NC0xLjYyNC0uODUtMy44NDgtLjkwNi00LjA5Ny0xLjUwMS00LjM1Mi0yLjA1OS0uMjU5LS41NjUtLjE5LTEuMjMuMjA1LTEuOTc3IDEuNzI2LTMuMjU3IDIuMDktNi4wMjQgMS4wMjctNy43OS0uNjc0LTEuMTE5LTEuODc1LTEuNzM0LTMuMzgzLTEuNzM0LTEuNTIxIDAtMi43MzIuNjI2LTMuNDA5IDEuNzYzLTEuMDY2IDEuNzg5LS42OTMgNC41NDQgMS4wNDkgNy43NTcuNDAyLjc0Mi40NzYgMS40MDYuMjIgMS45NzQtLjI2NS41ODYtLjYxMSAxLjE5LTQuMzY1IDIuMDY2LS44NTIuMTk2LTEuMzQyLjQ0OS0xLjYyMy44NDggMi4wMTIgMi4yMDcgNC45MSAzLjU5MiA4LjEyOCAzLjU5MnM2LjExNS0xLjM4NSA4LjEyNy0zLjU5em0uNjUtLjc4MmMxLjM5NS0xLjg0NCAyLjIyMy00LjE0IDIuMjIzLTYuNjI4IDAtNi4wNzEtNC45MjktMTEtMTEtMTFzLTExIDQuOTI5LTExIDExYzAgMi40ODcuODI3IDQuNzgzIDIuMjIyIDYuNjI2LjQwOS0uNDUyIDEuMDQ5LS44MSAyLjA0OS0xLjA0MSAyLjAyNS0uNDYyIDMuMzc2LS44MzYgMy42NzgtMS41MDIuMTIyLS4yNzIuMDYxLS42MjgtLjE4OC0xLjA4Ny0xLjkxNy0zLjUzNS0yLjI4Mi02LjY0MS0xLjAzLTguNzQ1Ljg1My0xLjQzMSAyLjQwOC0yLjI1MSA0LjI2OS0yLjI1MSAxLjg0NSAwIDMuMzkxLjgwOCA0LjI0IDIuMjE4IDEuMjUxIDIuMDc5Ljg5NiA1LjE5NS0xIDguNzc0LS4yNDUuNDYzLS4zMDQuODIxLS4xNzkgMS4wOTQuMzA1LjY2OCAxLjY0NCAxLjAzOCAzLjY2NyAxLjQ5OSAxIC4yMyAxLjY0LjU5IDIuMDQ5IDEuMDQzeiIvPjwvc3ZnPg=='
          }
        })
        console.log(newPin)

        // done
        this.$emit('earthflow')
        this.msgs = []
      })
    },
    registerPin ({ data }) {
      return eAPI.createPin({ data })
    },
    run () {
      let WE = window.WE
      let MAP = WE.map
      var options = {
        atmosphere: true,
        center: [0, 0],
        zoom: 0,
        sky: true
      }
      var earth = new MAP('earth_div', options)
      window.WE.tileLayer('http://tileserver.maptiler.com/nasa/{z}/{x}/{y}.jpg', {
        minZoom: 0,
        maxZoom: 6,
        attribution: 'NASA'
      }).addTo(earth)

      var before = null
      requestAnimationFrame(function animate (now) {
        var c = earth.getPosition()
        var elapsed = before ? now - before : 0
        before = now
        earth.setCenter([c[0], c[1] + 0.1 * (elapsed / 30)])
        requestAnimationFrame(animate)
      })
    }
  }
}
</script>

<style scoped>
#earth_div{
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
}
.abspos{
  position: absolute;
  top: 0px;
  left: 0px;
  color: white;
  width: 100%;
  height: 100%;

  background-color: rgba(56, 56, 56, 0.596);
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.all-center{
  text-align: center;
}

.privacy{
  white-space: pre-wrap;
}
.disclaimer{
  white-space: pre-wrap;
}
.red{
  color: red;
}

.linker{
  color: rgb(160, 177, 255);
  text-decoration: underline;
}
.marginer{
  margin: 0px auto;
  width: 500px;
}
</style>
